import type { MainEventViewerState } from '@/services/events/main-event';

/**
 * What the events-list corner ribbon should say, if anything.
 *
 * For SURVIVOR the useful fact is not that you entered but whether you are
 * still in it, so the pool reports Alive / Eliminated and every other format
 * reports Entered.
 *
 * Returns null in two distinct cases that must stay distinct: the viewer is
 * signed out (`viewer` undefined, so we do not KNOW), and the viewer is signed
 * in but has not entered. Both render nothing, but conflating them in the API
 * would mean a cached signed-out page could show someone else's badge.
 */
export function ribbonStanding(
  viewer?: MainEventViewerState,
): { label: string; eliminated: boolean } | null {
  if (!viewer?.entered) return null;
  if (viewer.survivorStatus === 'ELIMINATED') {
    return { label: 'Eliminated', eliminated: true };
  }
  if (viewer.survivorStatus === 'ALIVE') {
    return { label: 'Alive', eliminated: false };
  }
  return { label: 'Entered', eliminated: false };
}
